import React, { useContext, useEffect, useState } from "react";
import { APICall } from "../../Helpers/Network/APICalls";
import {
  documentDetails,
  getConfigValues,
  loanModuleGetPersonalDetailsByMemberId,
  postLoanRequestStatus,
  updateMemberAgreement,
} from "../../Helpers/APIEndPoints/EndPoints";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { useSelector } from "react-redux";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";
import { LoanTypeEnum } from "../../Helpers/Enums/Enum";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { downloadBlob } from "../../Helpers/Common/BlobHelper";
import BaseModal from "../../Components/BaseModel/BaseModel";
import { AutoCompleteValue } from "../../Components/InputForm/InputForm";
import ImageViewer from "../../Components/ImageViewer/ImageViewer";

const AgreementDisbursement = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [aggMitcAddress, setAggMitcAddress] = useState<any>();
  const [hideAggrementShortTerm, setHideAggrementShortTerm] = useState(false);
  const [isResetClick, setIsResetClick] = useState(false);
  const [memberAddress, setMemberAddress] = useState("");
  const [statusId, setStatusId] = useState();
  const [confirmValue, setConfirmValue] = useState<any>("");
  let navigate = useNavigate();
  const loanParameters = useSelector<any>(
    (states) => states?.LoanModuleReducer
  );
  const context = getContext();
  const [isModalOpen, setModalOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState<number>(null);
  const [images, setImages] = useState([]);
  const [imageEyeIconVisibleNextTab, setImageEyeIconVisibleNextTab] =
    useState(false);
  const [agreementName, setAgreementName] = useState(null);
  const [error, setError] = useState<any>({});
  const [agreementUploadDisabled, setAgreementDisabled] = useState(true);
  const [binaryDataAgreement, setBinaryDataAgreement] = useState(null);
  const [data, setData] = useState({
    uploadAgreement: "",
    agreement: null,
  });
  let documentId = [];
  useEffect(() => {
    callGetConfigData();
  }, []);

  useEffect(() => {
    if (isResetClick) {
      getPersonalDetailsById();
    }
  }, [isResetClick]);

  const callGetConfigData = async () => {
    showLoader();
    const params = ["MITCADDRESS"];

    const configdata = await APICall(getConfigValues, { Keys: params });

    if (configdata.Message == "Ok" && configdata.Data.length > 0) {
      configdata.Data.map((cd) => {
        if (cd.Key === "MITCADDRESS") {
          setAggMitcAddress(cd.Value);
          setIsResetClick(true);
        }
      });
    }
    hideLoader();
  };

  const getPersonalDetailsById = async () => {
    showLoader();
    let requestParams = loanParameters?.["loanParameters"];

    const res = await APICall(
      loanModuleGetPersonalDetailsByMemberId,
      requestParams
    );
    
    if (res.Message === "Ok" && res.Data !== null) {
      if (res?.Data?.Lrd_LoanType === LoanTypeEnum.LONGTERM) {
        setHideAggrementShortTerm(true);
      }
      setMemberAddress(res.Data.ResidentialAddress);
      setStatusId(res?.Data?.Lrd_StatusId);

      if (res?.Data?.Lrd_AgreementDocId != 0) {
        setImageEyeIconVisibleNextTab(true);
      }

      let newImages = [];
      const img = res?.Data?.Lrd_AgreementDocUrl;
      let imgUrl = await downloadBlob(img);
      let fileType = img?.toLowerCase()?.endsWith(".pdf") ? "pdf" : "image";
      newImages.push({
        src: imgUrl,
        fileType: fileType,
        title: "Agreement Document" + res?.Data?.Mkd_AccountHolderName,
      });
      setImages(newImages);

      if (
        [
          LoanStatus.LoanModule_MemberSignaturePending,
          LoanStatus.LoanModule_MemberSignatureVerificationRejected,
        ].includes(res?.Data?.Lrd_StatusId)
      ) {
        setAgreementDisabled(false);
      }

      hideLoader();
    } else {
      notify(ToastType.Error, "Data not found");
      hideLoader();
    }
  };

  //   const InnerHTML = ({ text }) => {
  //     const htmlContent = { __html: text };
  //     return <div dangerouslySetInnerHTML={htmlContent}></div>;
  //     {/* {hideAggrementShortTerm && <InnerHTML text={memberAddress} />} */}
  //   };

  const onSubmit = async () => {
    showLoader();
    let param = {
      StatusId:
        confirmValue == "NO"
          ? LoanStatus.LoanModule_MemberSignatureVerificationRejected
          : LoanStatus.LoanModule_LoanCommitteeApprovalPending,
      LoanRequestId: loanParameters?.["loanParameters"]?.["LoanId"],
      UserIdApproval: context?.Id,
      MemberId: context?.MemberId,
    };
    let resp = await APICall(postLoanRequestStatus, param);
    if (resp?.Status == ApiStatus.OK) {
      notify(
        ToastType.Success,
        confirmValue == "NO"
          ? "Agreement Rejected Successfully"
          : "Agreement Accepted Successfully"
      );
      navigate("/LoanApprovalDashboard");
    } else {
      notify(ToastType.Error, resp?.Message || "Please try again later.");
      return;
    }

    hideLoader();
  };

  const isFile = (input: any) => "File" in window && input instanceof File;

  const getBase64FromFilePromise = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (isFile(file) === true) {
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
      }
      reader.onerror = (error) => reject(error);
    });

  const onChangeAgreement = async (key, value) => {
    if (key === "agreement" && value.target.files.length > 0) {
      let errormessage = "agreementError";

      let e = value.target.files[0].name;
      let file = value.target.files[0];
      let extension = ["pdf"];
      let validfile = e.split(".").pop();
      setAgreementName(e);
      if (!extension.includes(validfile)) {
        setError({
          ...error,
          [errormessage]: "File should be only pdf",
        });
        value = file.name;
      } else if (file.size / 1024 / 1024 > 2) {
        setError({
          ...error,
          [errormessage]: "Please select file size upto 2mb",
        });
        value = file.name;
      } else {
        setError({
          ...error,
          [errormessage]: "",
        });
        let tempString: any = await getBase64FromFilePromise(file);
        let fileBase64 = "";
        if (tempString && tempString !== "") {
          fileBase64 = String(tempString).split("base64,")[1];
        }
        setImageEyeIconVisibleNextTab(false);
        setBinaryDataAgreement(fileBase64);
        value = fileBase64;
      }
    }
    setData({ ...data, [key]: value });
  };

  const handleCloseModal = (value: any = "NO") => {
    setConfirmValue(value);
    setImages([]);
    setError({});
    isModalOpen == true ? setModalOpen(false) : setModalOpen(true);
  };

  const ModalDesign = () => {
    // switch (statusId) {
    //   case LoanStatus.LoanModule_LoanAgreementPending:
    //     break;
    //   case LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam:

    //     break;
    //   default:
    //     break;
    // }

    return (
      <>
        <div className="ModalSize">
          <label
            className="d-block"
            style={{
              fontWeight: "bold",
              marginBottom: "10px",
              fontFamily: "var(--bs-body-font-family)",
              fontSize: "var(--bs-body-font-size)",
            }}
          >
            {[
              LoanStatus.LoanModule_MemberSignaturePending,
              LoanStatus.LoanModule_MemberSignatureVerificationRejected,
            ].includes(statusId) && (
              <>
                {/* <p style={{ fontSize: "15px", fontWeight: "600" }}>
                  Please sign the document before Upload
                </p> */}

                <div className="p-0">
                  <div className="col-lg-12 col-md-12">
                    <div
                      className="row"
                      style={{ marginLeft: "-30px", marginRight: "-30px" }}
                    >
                      <div
                        className={
                          imageEyeIconVisibleNextTab
                            ? "col-lg-5 col-sm-5 col-xs-5 " +
                              imageEyeIconVisibleNextTab
                            : "col-lg-6 col-sm-6 col-xs-6 " +
                              imageEyeIconVisibleNextTab
                        }
                      >
                        <div className="form-group"></div>
                        <label>Please sign the document before Upload</label>
                        {/* <sup>*</sup> */}

                        <input
                          autoComplete={AutoCompleteValue}
                          name="file-8[]"
                          id="file-8-agreement"
                          className="form-control inputfile inputfile-6"
                          onChange={(e) => onChangeAgreement("agreement", e)}
                          type="file"
                          disabled={agreementUploadDisabled}
                        />
                        <label
                          htmlFor="file-8-agreement"
                          className="form-control"
                          style={{ border: "1px" }}
                        >
                          <span style={{ float: "right" }}>
                            {agreementName}
                          </span>
                          <strong
                            style={{
                              width: "30%",
                              left: "0",
                              borderTopRightRadius: "0",
                              borderBottomRightRadius: "0",
                            }}
                          >
                            <i className="far fa-file"></i> Browse
                          </strong>{" "}
                        </label>
                        <div>
                          <p style={{ fontSize: "11px" }}>
                            {" "}
                            File extension should be pdf
                          </p>
                        </div>

                        {error[agreementName] || error["agreementError"] ? (
                          <p style={{ color: "red" }}>
                            {error[agreementName] || error["agreementError"]}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {[
              LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
            ].includes(statusId) && (
              <>
                {confirmValue == "NO" ? (
                  <p>Agreement Rejected by internal team</p>
                ) : (
                  <p>Agreement Accepted by internal team</p>
                )}
              </>
            )}
          </label>

          <div className="row justify-content-end no-gutters">
            <div className="col-auto">
              <button
                onClick={() => {
                  setModalOpen(false);
                }}
                className="btn btn-secondary btn-sm mx-2"
              >
                No
              </button>
            </div>
            <div className="col-auto">
              <button
                onClick={
                  [
                    LoanStatus.LoanModule_MemberSignaturePending,
                    LoanStatus.LoanModule_MemberSignatureVerificationRejected,
                  ].includes(statusId)
                    ? onSubmitUploadAgreement
                    : onSubmit
                }
                id={"saveBtn"}
                className="btn btn-secondary btn-sm"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  const onSubmitUploadAgreement = async () => {
    let errorObj = {};

    // if (!binaryDataAgreement && !agreementUploadDisabled) {
    //   errorObj = {
    //     ...errorObj,
    //     ["agreementError"]: "Invalid Salary Slip",
    //   };
    // }
    
    if (Object.keys(errorObj).length === 0) {
      showLoader();

      for (const key in data) {
        if (data.agreement) {
          if (key == "agreement") {
            let param = {
              DocumentName: agreementName,
              DocumentType: agreementName.split(".").pop(),
              DocumentUrl: "",
              BinaryFile: binaryDataAgreement || data.agreement,
            };
          
            const insertData = await APICall(documentDetails, param);
            if (insertData.Status === ApiStatus.OK && insertData?.Data) {
              let obj = { [key]: insertData.Data };
              documentId.push(obj);
            } else {
              notify(
                ToastType.Error,
                insertData?.Message ||
                  "Failed to upload document, Please try again later."
              );
              return;
            }
          }
        }
      }
      
      // if (documentId?.length > 0) {
        let param = {
          AgreementDocId: documentId[0]?.agreement ? documentId[0]?.agreement : null,
          StatusId: documentId[0]?.agreement
            ? LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam
            : LoanStatus.LoanModule_LoanCommitteeApprovalPending,
          LoanRequestId: loanParameters?.["loanParameters"]?.["LoanId"],
          UserIdApproval: context?.Id,
          MemberId: context?.MemberId,
        };
        
        // let param = {
        //   AgreementDocId: documentId[0]?.agreement
        //     ? documentId[0]?.agreement
        //     : null,
        //   StatusId:
        //     LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
        //   LoanRequestId: loanParameters?.["loanParameters"]?.["LoanId"],
        //   UserIdApproval: context?.Id,
        //   MemberId: context?.MemberId,
        // };
        
        const insertData = await APICall(updateMemberAgreement, param);
        if (insertData.Status === ApiStatus.OK) {
          const message =
            param.StatusId ===
            LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam
              ? "Document Signed Successfully"
              : "Document Signed Successfully";

          notify(ToastType.Success, message);
          navigate("/LoanApprovalDashboard");
          // notify(ToastType.Success, "Document Signed Successfully");
          // navigate("/LoanApprovalDashboard");
        }

        hideLoader();
      // } else {
      //   notify(
      //     ToastType.Error,
      //     "Failed to upload document, Please try again later."
      //   );
      //   hideLoader();
      //   return;
      // }
    } else {
      setError(errorObj);
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      {[
        LoanStatus.LoanModule_MemberSignaturePending,
        LoanStatus.LoanModule_MemberSignatureVerificationRejected,
      ].includes(statusId) && (
        <>
          <p style={{ fontSize: "15px", fontWeight: "600" }}>
            An agreement and application has sent to your address mentioned
          </p>
          <p>{memberAddress}</p>
          <p style={{ fontSize: "15px", fontWeight: "600" }}>
            {/* After Signing it, Please courier the to the address mentioned */}
            After signing it, please courier the agreement to the office address mentioned below:
          </p>
          <p>{aggMitcAddress}</p>
          <p>(Click Submit once you have sent the courier)</p>
        </>
      )}
      {[
        LoanStatus.LoanModule_MemberSignatureVerificationPendingByInternalTeam,
      ].includes(statusId) && (
        <>
          <div>
            <p style={{ fontSize: "15px", fontWeight: "600" }}>
              Agreement recevied from Member to internal team
            </p>
            {imageEyeIconVisibleNextTab && (
              <div
                onClick={() => {
                  window.open(images?.[0]?.src, "_blank");
                }}
              >
                Click Here To Visit Document{" "}
                <i className="fa fa-eye" aria-hidden="true"></i>
              </div>
            )}
          </div>
        </>
      )}

      <div className="centerAlign">
        <div
          className="p-2 d-flex justify-content-end"
          style={{ marginTop: 30 }}
        >
          <ButtonComponent
            icon={"fa-solid"}
            value={
              [
                LoanStatus.LoanModule_MemberSignaturePending,
                LoanStatus.LoanModule_MemberSignatureVerificationRejected,
              ].includes(statusId)
                ? "NO"
                : "Reject"
            }
            style={{ marginLeft: "10px" }}
            className="btn btn-primary"
            onClick={() => {
              [
                LoanStatus.LoanModule_MemberSignaturePending,
                LoanStatus.LoanModule_MemberSignatureVerificationRejected,
              ].includes(statusId)
                ? navigate("/LoanApprovalDashboard")
                : handleCloseModal("NO");
            }}
          />

          <ButtonComponent
            icon={""}
            value={
              [
                LoanStatus.LoanModule_MemberSignaturePending,
                LoanStatus.LoanModule_MemberSignatureVerificationRejected,
              ].includes(statusId)
                ? "YES"
                : "Accept"
            }
            style={{ marginLeft: "10px" }}
            id={"saveBtn"}
            onClick={() => {
              handleCloseModal("YES");
            }}
          />
        </div>
      </div>

      <BaseModal
        buttonText={""}
        open={isModalOpen}
        content={<ModalDesign />}
        onclose={handleCloseModal}
      />
    </div>
  );
};

export default AgreementDisbursement;
